// ============================================================================
// Assurance - Page Rupture / Visualisation (conteneur)
// Affiche la page enfant selon l'URL :
//   /assurance/rupture              -> ProduitAdmin (par défaut)
//   /assurance/rupture/mes-souscriptions -> MesSouscriptions
// ============================================================================

import { useParams } from 'react-router-dom';
import ProduitAdmin from './ProduitAdmin';
import MesSouscriptions from './MesSouscriptions';

const VisualisationPage = () => {
  const { type } = useParams<{ type?: string }>();

  if (type === 'mes-souscriptions') return <MesSouscriptions />;
  return <ProduitAdmin />;
};

export default VisualisationPage;
